export interface StatCardOptions {
  label: string;
  value: string;
  dotColor?: string;
  subtext?: string;
}

export function statCard(opts: StatCardOptions): string {
  const dot = opts.dotColor ? `<div class="w-2 h-2 rounded-full ${opts.dotColor}"></div>` : '';
  const sub = opts.subtext ? `<p class="text-xs text-th-text-4 mt-1.5">${opts.subtext}</p>` : '';
  return `
    <div class="bg-th-card rounded-2xl border border-th-border p-5 stat-card">
      <div class="flex items-center gap-2 mb-2">
        ${dot}
        <p class="text-[11px] text-th-text-3 font-medium uppercase tracking-wider">${opts.label}</p>
      </div>
      <p class="text-2xl font-bold text-th-text">${opts.value}</p>
      ${sub}
    </div>
  `;
}

export interface GlassStatOptions {
  label: string;
  value: string;
  dotColor?: string;
}

export function glassStatCard(opts: GlassStatOptions): string {
  const dot = opts.dotColor ? `<div class="w-2 h-2 rounded-full ${opts.dotColor} shadow-sm shadow-current/50"></div>` : '';
  return `
    <div class="glass rounded-xl sm:rounded-2xl px-3 py-2.5 sm:px-5 sm:py-4 stat-card group shrink-0">
      <div class="flex items-center gap-2 mb-1">
        ${dot}
        <p class="text-[10px] sm:text-[11px] text-th-text-3 font-medium uppercase tracking-wider">${opts.label}</p>
      </div>
      <p class="text-xl sm:text-3xl font-bold text-th-text">${opts.value}</p>
    </div>
  `;
}

export interface EntityCardOptions {
  href: string;
  header: string;
  badge?: string;
  rows: { label: string; value: string }[];
  icon?: string;
}

export function entityCard(opts: EntityCardOptions): string {
  const rows = opts.rows.map(r => `
    <div>
      <p class="text-[11px] text-th-text-3 font-medium uppercase tracking-wider">${r.label}</p>
      <p class="text-th-text-2 mt-0.5">${r.value}</p>
    </div>
  `).join('');
  return `
    <a href="${opts.href}" class="block bg-th-card rounded-2xl border border-th-border p-5 hover:bg-th-card-hover hover:border-th-border-2 transition-all duration-300 group card-glow">
      <div class="flex items-center justify-between mb-4">
        <div class="flex items-center gap-3">
          ${opts.icon ? `<div class="w-10 h-10 rounded-xl bg-th-surface ring-1 ring-th-border-2 flex items-center justify-center">${opts.icon}</div>` : ''}
          <p class="font-semibold group-hover:text-blue-400 transition-colors">${opts.header}</p>
        </div>
        ${opts.badge || ''}
      </div>
      <div class="grid grid-cols-2 gap-3 text-sm">${rows}</div>
    </a>
  `;
}
